import { LoadingOutlined } from '@ant-design/icons-vue'
import { h } from 'vue'

export default h(LoadingOutlined, {
  style: {
    fontSize: '24px'
  },
  spin: true
})
